import React, { useEffect, useState } from "react";

const GoogleTranslate = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "en"
  );

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (!document.querySelector('script[src*="translate_a/element.js"]')) {
        const script = document.createElement("script");
        script.src =
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      } else if (window.google?.translate?.TranslateElement) {
        window.googleTranslateElementInit();
      }
    };

    window.googleTranslateElementInit = () => {
      if (document.getElementById("google_translate_element")?.innerHTML === "") {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", autoDisplay: false },
          "google_translate_element"
        );
      }
    };

    const applyLanguage = (lang) => {
      const iframe = document.querySelector("iframe.goog-te-menu-frame");
      if (!iframe) return;

      const selectLang = () => {
        const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        const langLinks = innerDoc.querySelectorAll(".goog-te-menu2-item span.text");
        langLinks.forEach((el) => {
          if (el.innerText.toLowerCase().includes(lang.toLowerCase())) {
            el.click();
          }
        });
      };

      setTimeout(selectLang, 500);
    };

    const waitForTranslateElement = () => {
      const interval = setInterval(() => {
        const translateCombo = document.querySelector(".goog-te-combo");
        if (translateCombo) {
          clearInterval(interval);

          const setPlaceholderWhenReady = () => {
            if (translateCombo.options.length > 0) {
              translateCombo.options[0].text = "Language";
              translateCombo.options[0].value = "";
            } else {
              setTimeout(setPlaceholderWhenReady, 200);
            }
          };
          setPlaceholderWhenReady();

          translateCombo.addEventListener("change", () => {
            setSelectedLanguage(translateCombo.value);
            localStorage.setItem("selectedLanguage", translateCombo.value);
          });

          if (selectedLanguage && selectedLanguage !== "en") {
            translateCombo.value = selectedLanguage;
            translateCombo.dispatchEvent(new Event("change"));
            applyLanguage(selectedLanguage);
          }

          removeUnwantedElements();
        }
      }, 500);
    };

    const removeUnwantedElements = () => {
      const style = document.createElement("style");
      style.innerHTML = `
        .goog-logo-link,
        .goog-te-gadget > span,
        .goog-te-banner-frame,
        .goog-te-menu-frame.skiptranslate,
        .goog-te-banner-frame.skiptranslate {
          display: none !important;
        }

        body { top: 0px !important; }
        body > .skiptranslate { display: none !important; }
        * { user-select: none; }
        .goog-te-gadget-icon { display: none !important; }
        .goog-te-gadget { font-size: 0px !important; }

        .goog-te-combo {
          background-color: #000000;
          padding: 5px;
          border: 2px solid white;
          margin: 0px;
          color: white;
          font-weight: bold;
          font-size: 10px;
          width: 100%;
          display: flex;
          border-radius: 9999px;
          padding-left: 16px;
          padding-right: 16px;
          align-items: center;
          padding-top: 8px;
          padding-bottom: 8px;
          font-size: 0.75rem;
          cursor: pointer;
          transition: all 0.3s ease-in-out;
          box-shadow: none;
        }

        .goog-te-combo:hover {
          box-shadow: 0 0 14px rgba(255, 255, 255, 0.8);
        }

        @media (min-width: 1536px) {
          .goog-te-combo {
            font-size: 1rem;
          }
        }

        .goog-te-combo option { color: white; }
        .goog-te-combo option[value=""] {
          color: white;
          font-weight: bold;
        }

        #goog-gt-tt { display: none !important; }
        .VIpgJd-yAWNEb-VIpgJd-fmcmS-sn54Q {
          background-color: transparent;
          box-shadow: none;
          position: static;
        }
        .VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc { display: none; }
      `;
      document.head.appendChild(style);
    };

    addGoogleTranslateScript();
    waitForTranslateElement();

    return () => {
      const combo = document.querySelector(".goog-te-combo");
      if (combo) {
        combo.removeEventListener("change", () => { });
      }
    };
  }, []);

  return (
    <div className="absolute md:fixed top-5 lg:top-7 2xl:top-9 right-12 md:right-16 lg:right-[12%] w-[120px] md:w-[130px] 2xl:w-[150px]" style={{ zIndex: 99 }}>
      <div id="google_translate_element" />
    </div>
  );
};

export default GoogleTranslate;
